import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { ActivationServiceResult } from '../interfaces/activation/activation-service-result';

@Injectable({
  providedIn: 'root',
})
export class PaymentConfigService extends BaseCrudService<any, any> {

  baseUrl = this.runtimeConfig.dataBackend;

  /**
   * Create a config over the config api
   * @param routeEndpoint
   * @param body
   */
  createConfig(routeEndpoint: string, body: any): Observable<ActivationServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.post<ServiceResult>(this.baseUrl + routeEndpoint, body, { headers: headers });
  }

}
